import { Model } from 'modules/core/lib/mobx-rest'

interface IFeature {
  [key: string]: any
}
class Feature extends Model<IFeature> {
  static urlRoot() {
    return '/features'
  }
}

export default Feature
